/* Keeps the first hero slide on screen a little longer than the rest.
   Change EXTRA (milliseconds) to adjust. The normal slide time is set in the theme editor. */
(function () {
  var EXTRA = 2000;

  function patch(sc) {
    if (!sc.slider || sc.slider.dataset.autoplay !== 'true' || sc.__firstHold) return;
    sc.__firstHold = true;

    function slideWidth() {
      return sc.slider.querySelector('.slideshow__slide').clientWidth || 1;
    }
    function index() {
      return Math.round(sc.slider.scrollLeft / slideWidth());
    }

    sc.play = function () {
      sc.slider.setAttribute('aria-live', 'off');
      clearTimeout(sc.autoplay);
      var wait = sc.autoplaySpeed + (index() === 0 ? EXTRA : 0);
      sc.autoplay = setTimeout(function () {
        var next = (index() + 1) % sc.sliderItems.length;
        sc.slider.scrollTo({ left: next * slideWidth() });
        sc.autoplay = setTimeout(function () { sc.play(); }, 50);
      }, wait);
    };

    sc.pause = function () {
      sc.slider.setAttribute('aria-live', 'polite');
      clearTimeout(sc.autoplay);
    };

    clearInterval(sc.autoplay);
    if (sc.autoplayButtonIsSetToPlay) sc.play();
  }

  customElements.whenDefined('slideshow-component').then(function () {
    document.querySelectorAll('slideshow-component').forEach(patch);
  });
})();
